// extracted by mini-css-extract-plugin
export default {"share_modal__title":"shareModal_share_modal__title__iuO4Y","share_modal__link":"shareModal_share_modal__link__I6Vve","share_modal__buttons":"shareModal_share_modal__buttons__A5ElZ"};